import { render } from "./ScheduledSnapshots.vue?vue&type=template&id=74bea832&scoped=true"
import script from "./ScheduledSnapshots.vue?vue&type=script&lang=js"
export * from "./ScheduledSnapshots.vue?vue&type=script&lang=js"

import "./ScheduledSnapshots.vue?vue&type=style&index=0&id=74bea832&lang=less&scoped=true"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bea832"]])

export default __exports__